module.exports = __webpack_public_path__ + "img/kopsurat_jmc_sm.c56a97a5.png";